export class Enemy {
    public progress: number = 0;
    public max_health: number = 10;

    constructor(
        public health: number = 10,
        public speed: number = 1,
    ) {
        this.max_health = health;
    }
}